module.exports = __webpack_public_path__ + "static/media/概览.f9d32763.svg";